import cx from 'classnames';
import {useTranslation} from 'react-i18next';

import {TRANSLATION_KEYS} from 'locale';

import {SessionStatusMap, SessionStatusFilter} from '../OnlineSessions';

const T_KEYS = TRANSLATION_KEYS.ONLINE_SESSIONS_PAGE;

type Props = {
    sessionStatusMap: SessionStatusMap,
    selectedSessionStatusFilter: SessionStatusFilter,
    setSelectedSessionStatusFilter: (status: SessionStatusFilter) => void;
};

export const SessionStatusChips: React.FC<Props> = ({
    sessionStatusMap, selectedSessionStatusFilter, setSelectedSessionStatusFilter
}: Props) => {
    const {t} = useTranslation();
    return (
        <div className='tw-flex tw-items-center -sm:tw-order-2 -sm:tw-my-4'>
            {Object.keys(sessionStatusMap).map((sessionStatus) => {
                const isSelectedStatus = selectedSessionStatusFilter === SessionStatusFilter[sessionStatus];
                return (
                    <div
                        key={sessionStatus}
                        className={cx('tw-py-0.5 tw-px-2 tw-mr-2 tw-rounded-2xl tw-border tw-cursor-pointer', {
                            'tw-text-light tw-bg-primary tw-border-primary': isSelectedStatus,
                            'tw-text-default-dimmed tw-border-default-dimmed': !isSelectedStatus
                        })}
                        onClick={() => setSelectedSessionStatusFilter(SessionStatusFilter[sessionStatus])}
                    >
                        {`${sessionStatusMap[sessionStatus]} ${t(T_KEYS.FILTERS.STATUSES[sessionStatus])}`}
                    </div>
                );
            })}
        </div>
    );
};